import type { ComponentSchema } from '../../../../../schema-types'
import { schema as shared } from '../../../../lightings/lightings-1/sections/shop/shop-grid.schema'

/** Fresh Basket listing: the shared shop fields plus page sizes shoppers can pick. */
export const schema: ComponentSchema = {
  ...shared,
  commonFields: [
    ...shared.commonFields,
    { key: 'pageSizes', label: 'Extra page sizes', type: 'string', placeholder: '24, 48', help: 'Offered next to "Products per page"; leave empty for one size.' },
  ],
}
